<template>
    <div class="data-grid d-flex justify-content-center align-items-center flex-column">
        <div v-if="loading"><i class="fas fa-star fa-2x fa-spin text-primary"></i></div>
        <slot v-if="!loading"></slot>
    </div>
</template>

<script>
    export default {
        props: {
            loading: {default: true},
        }
    };
</script>
